<template>
  <v-container class="view">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="4" class="justify-center text-center">
        <h2>Get in touch<br /></h2>

        <p class="sub-hero-text">Let&apos;s talk about everything.</p>
        <v-form
          v-model="valid"
          lazy-validation
          ref="form"
          @submit.prevent="contact_us"
        >
          <v-text-field
            v-model="name"
            :rules="name_rules"
            label="Your name"
            required
            placeholder="Jane Doe"
            outlined
          ></v-text-field>

          <v-text-field
            v-model="email"
            :rules="email_rules"
            label="Your Email"
            required
            outlined
            placeholder="jane@mailer.com"
          ></v-text-field>

          <v-text-field
            v-model="subject"
            :rules="subject_rules"
            label="Subject"
            required
            placeholder="subject"
            outlined
          ></v-text-field>

          <v-textarea
            v-model="message"
            :rules="message_rules"
            label="Your message"
            required
            outlined
            placeholder=" your message"
          ></v-textarea>

          <v-btn
            type="submit"
            large
            color="var(--purple)"
            class="justify-center text-center white--text"
            :loading="loading"
            :disabled="loading"
            style="width: 97%"
          >
            Send
          </v-btn>
        </v-form>
        <!--modal to return mail sent status-->
        <v-snackbar
          v-model="snackbar"
          color="success"
          outlined
          buttom
          vertical
          light
          elevation="5"
        >
          {{ response }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="red"
              text
              v-bind="attrs"
              @click="
                snackbar = false;
                email = '';
                subject = '';
                (message = ''), (name = '');
              "
            >
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    email: "",
    name: "",
    subject: "",
    message: "",
    loading: false,
    loader: null,
    timeout: -1,
    response: "",
    snackbar: false,
    email_rules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    name_rules: [(v) => !!v || "Please provide your name"],
    subject_rules: [(v) => !!v || "E-mail subject is required"],
    message_rules: [(v) => !!v || "Message may not be empty"],
  }),

  methods: {
    async contact_us() {
      //validate input
      this.$refs.form.validate();
      this.loading = true; // fire up loadinf
      //destructure payload
      const { email, subject, name, message } = this;
      //send payload
      const response = await axios.post("/contact-us", {
        email,
        subject,
        name,
        message,
      });
      console.log(response.data.message);
      if (response.data.message) {
        //reset fields and send feed back
        this.response = response.data.message;
        this.loading = false;
        this.snackbar = true;
        /*  this.email = "";
        this.name = "";
        this.subject = "";
        this.message = ""; */
        this.timeout = 2500;
      }

      //console.log({ email, subject, name, message });
    },
  },
};
</script>

<style scoped>
img {
  width: 70%;
  margin: 0 auto;
}
</style>
